export default "__VITE_ASSET__5c861ddd__"